module.exports = __webpack_public_path__ + "img/draw.7c90395e.svg";